import React from 'react';
import './StarBorder.css';

/**
 * Borde animado tipo “star sweep” (adaptado de reactbits).
 * Velocidad por defecto lenta para un aspecto más formal; respeta prefers-reduced-motion.
 */
const StarBorder = ({
    as: Component = 'button',
    className = '',
    innerClassName = '',
    color = 'rgba(126, 189, 203, 0.38)',
    speed = '9s',
    thickness = 1,
    block = false,
    children,
    ...rest
}) => {
    const { style: restStyle, ...restProps } = rest;
    const outerClass = [
        'star-border-container',
        block ? 'star-border-container--block' : '',
        className
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <Component
            className={outerClass}
            style={{
                padding: `${thickness}px 0`,
                ...(restStyle || {})
            }}
            {...restProps}
        >
            <div
                className="star-border-gradient star-border-gradient--bottom"
                aria-hidden="true"
                style={{
                    background: `radial-gradient(circle, ${color}, transparent 10%)`,
                    animationDuration: speed
                }}
            />
            <div
                className="star-border-gradient star-border-gradient--top"
                aria-hidden="true"
                style={{
                    background: `radial-gradient(circle, ${color}, transparent 10%)`,
                    animationDuration: speed
                }}
            />
            {/* Capa opaca entre el brillo animado y el vidrio: evita que el gradiente se “suba” encima del contenido */}
            <div className="star-border-slab" aria-hidden="true" />
            <div className={`star-border-inner ${innerClassName}`.trim()}>{children}</div>
        </Component>
    );
};

export default StarBorder;
